module.exports = __webpack_public_path__ + "img/symbol_pfeilundbogen.023879f.jpg";